'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { useAnalyticsConsent } from './AnalyticsConsentProvider';
import {
  isGaConfigured,
  isGaEnabledForPath,
  trackGaPageView,
} from '../../lib/analytics';

/**
 * Sends manual GA4 page views on public routes only (`/admin/*` excluded).
 */
export function AnalyticsRouteListener() {
  const pathname = usePathname() ?? '/';
  const { consent, requireConsent } = useAnalyticsConsent();
  const lastTrackedPath = useRef<string | null>(null);

  const mayTrack =
    isGaConfigured() &&
    (!requireConsent || consent === 'granted') &&
    isGaEnabledForPath(pathname);

  useEffect(() => {
    if (!mayTrack) return;
    if (lastTrackedPath.current === pathname) return;

    lastTrackedPath.current = pathname;
    trackGaPageView(pathname);
  }, [mayTrack, pathname]);

  useEffect(() => {
    if (!requireConsent || consent !== 'granted') {
      lastTrackedPath.current = null;
    }
  }, [consent, requireConsent]);

  return null;
}
